import React, { Component } from 'react'
import { Route, withRouter } from 'react-router-dom'

class ScrollToTopRoute extends Component {
	componentDidUpdate = (prevProps) => {
		if (new RegExp("^" + this.props.path.replace(/:[^:^/]*/g, "[^/]*") + "$").test(this.props.location.pathname) && this.props.location.pathname !== prevProps.location.pathname) {
			window.scrollTo(0, 0)
		}
	}

	render() {
		const { component: Component, ...rest } = this.props

		return <Route component={this.props.component} {...rest}/>
	}
}

export default withRouter(ScrollToTopRoute)


// WEBPACK FOOTER //
// ./src/components/ScrollToTopRoute.js